import { render, staticRenderFns } from "./PatientsFormOpinionsPopup.vue?vue&type=template&id=9755e96a&"
import script from "./PatientsFormOpinionsPopup.vue?vue&type=script&lang=js&"
export * from "./PatientsFormOpinionsPopup.vue?vue&type=script&lang=js&"
import style0 from "./PatientsFormOpinionsPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports